<template>
	<button :class="`share-icon ${direction}`">
    
    <svg-share></svg-share>

    <Transition name="fade">
      <div class="share-icon-icons-container">
        <ul class="share-icon-icons">
          <li>
            <block-social-media-share network="facebook" :title="computedTitle"></block-social-media-share>
          </li>
          <li>
            <block-social-media-share network="twitter" :title="computedTitle"></block-social-media-share>
          </li>
          <li>
            <block-social-media-share network="linkedin" :title="computedTitle"></block-social-media-share>
          </li>
          <li>
            <block-social-media-share network="whatsapp" :title="computedTitle"></block-social-media-share>
          </li>
        </ul>
      </div>
    </Transition>
  </button>

</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

	export default {
		name: 'ShareIcon',
		mixins: [AuthMixins],

		props: {
			job_title: {
				type: String
			},
      direction: {
        type: String,
        default: 'right'
      }
		},

		data() {
			return {
			}
		},

    computed: {
      computedTitle() {
        return encodeURIComponent(this.job_title);
      }
    }
	}

</script>
